module.exports = __webpack_public_path__ + "static/img/xls.e0463277.png";